import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { InputPhoneControl } from '../../ui-kit/Input/InputPhoneControl.js';
import { withValidator } from '../../validation/withValidator.js';
import { validatorObj } from './getObjectValidator.js';
export const SecondaryPhoneField = JSX(({ field }) => {
    const fieldPhone = field('secondaryPhone');
    return (_jsx(InputPhoneControl, { label: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D", ...(!fieldPhone.value || fieldPhone.value === '+7 ('
            ? fieldPhone
            : withValidator(fieldPhone, validatorObj.secondaryPhone)) }));
});
//# sourceMappingURL=SecondaryPhoneField.js.map